<template>
  <div>
    <div v-if="data.slides">
      <section
          class="mbr-slider mbr-section mbr-section__container carousel slide mbr-section-nopadding mbr-after-navbar"
          data-ride="carousel" data-keyboard="false" data-wrap="true" data-pause="false" data-interval="10000"
          id="slider-2" data-rv-view="2">
        <div>
          <div>
            <div>
              <ol class="carousel-indicators">
                <li data-app-prevent-settings="" data-target="#slider-2" data-slide-to="0"
                    class="active"></li>
                <li data-app-prevent-settings="" data-target="#slider-2" class=""
                    data-slide-to="1"></li>
                <li data-app-prevent-settings="" data-target="#slider-2" data-slide-to="2"></li>
                <li data-app-prevent-settings="" data-target="#slider-2" data-slide-to="3"></li>
              </ol>
              <div class="carousel-inner" role="listbox">

                <!--                            <div class="mbr-section mbr-section-hero carousel-item dark center mbr-section-full active"-->
                <!--                                 data-bg-video-slide="https://www.youtube.com/watch?v=ltAu37dKPd8">-->
                <!--                                <video-bg class="mbr-table-cell" :sources="['video/bg-video.mp4']">-->
                <!--                                    <div class="mbr-overlay" style="opacity: 0.3;"></div>-->
                <!--                                    <div class="container-slide container bg-video-title">-->

                <!--                                        <div class="row">-->
                <!--                                            <div class="col-md-8 col-md-offset-1">-->
                <!--                                                <h2 class="mbr-section-title display-1">Alta Tecnologia na produção</h2>-->
                <!--                                                <p class="mbr-section-lead lead"></p>-->


                <!--                                            </div>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                </video-bg>-->
                <!--                            </div>-->

                <div class="mbr-section mbr-section-hero carousel-item dark center mbr-section-full active"
                     data-bg-video-slide="false"
                     style="background-image: url(assets/images/bg-alta-tecnologia.jpg);">
                  <div class="mbr-table-cell">
                    <div class="mbr-overlay"></div>
                    <div class="container-slide container">

                      <div class="row">
                        <div class="col-md-8 col-md-offset-1">
                          <h2 class="mbr-section-title display-1">{{ data.slides.s1 }}</h2>
                          <p class="mbr-section-lead lead"></p>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="mbr-section mbr-section-hero carousel-item dark center mbr-section-full"
                     data-bg-video-slide="false"
                     style="background-image: url(assets/images/dji-418-2000x1500.jpg);">
                  <div class="mbr-table-cell">
                    <div class="mbr-overlay"></div>
                    <div class="container-slide container">

                      <div class="row">
                        <div class="col-md-8 col-md-offset-2 text-xs-center">
                          <h2 class="mbr-section-title display-1">{{ data.slides.s2 }}</h2>
                          <p class="mbr-section-lead lead"></p>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mbr-section mbr-section-hero carousel-item dark center mbr-section-full"
                     data-bg-video-slide="false"
                     style="background-image: url(assets/images/bg-plantio.jpg);">
                  <div class="mbr-table-cell">
                    <div class="mbr-overlay"></div>
                    <div class="container-slide container">

                      <div class="row">
                        <div class="col-md-8 col-md-offset-3 text-xs-right">
                          <h2 class="mbr-section-title display-1">{{ data.slides.s3 }}</h2>
                          <p class="mbr-section-lead lead"></p>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mbr-section mbr-section-hero carousel-item dark center mbr-section-full"
                     data-bg-video-slide="false"
                     style="background-image: url(assets/images/bg-qualidade-graos.jpg);">
                  <div class="mbr-table-cell">
                    <div class="mbr-overlay"></div>
                    <div class="container-slide container">

                      <div class="row">
                        <div class="col-md-8 col-md-offset-3 text-xs-right">
                          <h2 class="mbr-section-title display-1">{{ data.slides.s4 }}</h2>
                          <p class="mbr-section-lead lead"></p>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <a data-app-prevent-settings="" class="left carousel-control" role="button"
                 data-slide="prev"
                 href="#slider-2">
                <span class="icon-prev" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a data-app-prevent-settings="" class="right carousel-control" role="button"
                 data-slide="next"
                 href="#slider-2">
                <span class="icon-next" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section class="mbr-section mbr-parallax-background" id="history" data-rv-view="17"
               style="background-image: url(assets/images/fazenda-732x543.jpg); padding-top: 120px; padding-bottom: 120px;">

        <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(0, 0, 0);">
        </div>

        <div class="container">
          <h3 class="mbr-section-title display-2">{{ data.history.title }}</h3>
          <div class="lead">
            <p>
              <strong>{{ data.history.sub }}<br></strong>
              {{ data.history.description }}
            </p>
          </div>
        </div>

      </section>
      <section class="mbr-section mbr-parallax-background" id="location" data-rv-view="20"
               style="background-image: url(assets/images/dji-24-2000x1500.jpg); padding-top: 40px; padding-bottom: 40px;">

        <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(34, 34, 34);">
        </div>

        <div class="mbr-section mbr-section__container mbr-section__container--middle">
          <div class="container">
            <div class="row">
              <div class="col-xs-12 text-xs-center">


              </div>
            </div>
          </div>
        </div>


        <div class="mbr-section mbr-section-nopadding">
          <div class="container">
            <div class="row">
              <div class="col-xs-12">
                <div v-for="item in data.differential" class="mbr-testimonial card">
                  <div class="card-block">{{ item.description }}
                  </div>
                  <div class="mbr-author card-footer">

                    <div class="mbr-author-name">{{ item.title }}</div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      <section class="mbr-section mbr-parallax-background" id="values" data-rv-view="28"
               style="background-image: url(assets/images/dji-38-2000x1500.jpg); padding-top: 0px; padding-bottom: 40px;">

        <div class="mbr-overlay" style="opacity: 0.5; background-color: rgb(34, 34, 34);">
        </div>

        <div class="mbr-section mbr-section__container mbr-section__container--middle">
          <div class="container">
            <div class="row">
              <div class="col-xs-12 text-xs-center">


              </div>
            </div>
          </div>
        </div>


        <div class="mbr-testimonials mbr-section mbr-section-nopadding">
          <div class="container">
            <div class="row">

              <div v-if="data.metas" v-for="item in data.metas" class="col-xs-12 col-lg-4">

                <div class="mbr-testimonial card">
                  <div class="card-block"><p>{{ item.description }}</p></div>
                  <div class="mbr-author card-footer">

                    <div class="mbr-author-name">{{ item.title }}</div>

                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      language: {},
      data: {},
      pt: {
        nav: {},
        slides: {
          s1: 'Alta Tecnologia na Produção',
          s2: 'Produção Própria da Matéria-Prima',
          s3: 'Plantio Especializado',
          s4: 'Alta Qualidade dos Grãos'
        },
        history: {
          title: 'BRMILL ALIMENTOS',
          sub: 'História',
          description: 'A BRMill Alimentos, empresa do grupo Agropecuária São Miguel, foi idealizada a partir da\n' +
              'necessidade em agregar valor aos grãos produzidos na região de Silvânia, estado de Goiás.\n' +
              'A junção dos fatores tecnologia, localização privilegiada, mão-de-obra e matéria prima,\n' +
              'permitiram o início desse projeto de processamento de grãos de milho via processo semi-\n' +
              'úmido, para a produção de matérias primas para indústrias de alimentos, fábricas de rações\n' +
              'e outros segmentos.\n' +
              'Devido a alta produtividade de matéria prima na região, tem-se total controle sobre a qualidade do produto GMO Free produzido pela BRMill Alimentos, pois este começa a ser\n' +
              'avaliado e rastreado desde a seleção de sementes feita pelos produtores parceiros até o\n' +
              'processo de moagem, cumprindo rigorosos critérios de produção.\n' +
              'Além disso, em seu planejamento estratégico, a empresa tem por objetivo promover o\n' +
              'desenvolvimento da região, que até então tinha suas bases fundamentadas na economia\n' +
              'agrícola, agregando valor à sociedade e à economia local.',
        },
        differential: [
          {
            title: 'Localização',
            description: 'A localização é privilegiada, pois na região, há grande demanda pelo consumo de produtos derivados de milho, além de ser uma posição estratégica para atender regiões em pleno desenvolvimento como Norte e Nordeste do país. Estabelecida no município de Silvânia-GO, a 120 Km de Goiânia, a empresa beneficia-se da privilegiada posição logística no centro do País, que permite atingir com facilidade o mercado nacional, bem como ter acesso rápido aos principais portos.\n' +
                'Outro fator que vale ser ressaltado é a oferta de matéria prima na região, conhecida pela qualidade e produtividade. A demanda da indústria será facilmente atendida pela originação de produtores locais, além da produzida na propriedade do grupo.'
          },
          {
            title: 'Soluções em Ingredientes Industriais\n',
            description: 'A BRMILL Alimentos é uma agroindústria especializada na produção de ingredientes à base de Milho, com foco em fornecer soluções para a indústria de transformação.\n' +
                '\n' +
                'Os produtos da BRMILL Alimentos classificados como Canjicão, Canjicas, Grits, Sêmolas, Fubá, são produzidos com a finalidade de atender os seguintes segmentos: indústrias de salgadinhos, “snacks”, pipocas doces, cervejarias, coloríficos, temperos, misturas para bolos, moageiras e empacotamento direto para varejo, além de outras empresas no ramo de adesivos, papéis, têxtil, mineração. O Gérmen de milho se destina às indústrias de formulação de rações para animais e extração de óleos.'
          }
        ],
        metas: [
          {
            title: 'MISSÃO',
            description: 'Oferecer produtos derivados do milho, com alta qualidade e tecnologia, buscando maximizar os resultados da empresa e dos clientes, a partir de uma evolução contínua da equipe e dos processos.'
          },
          {
            title: 'VISÃO',
            description: 'Ser uma indústria de alta performance no segmento alimentício, valorizada pelos clientes por suas soluções diferenciadas e eficazes.'
          },
          {
            title: 'VALORES',
            description: 'Pautada pela ética, transparência e integridade de conduta, seja com clientes, seja com parceiros, seja com a comunidade, a empresa busca incessantemente a excelência.'
          }
        ],
        footer: {}
      },
      en: {
        nav: {},
        slides: {
          s1: 'High Technology in Production',
          s2: 'Own Raw Material Production',
          s3: 'Specialized Planting',
          s4: 'High Quality of Grains'
        },
        history: {
          title: 'COMPANY',
          sub: 'HISTORY',
          description: 'BRMill Alimentos, Agropecuária São Miguel group company, was idealized based on the\n' +
              'necessity to add value to the grains produced in the region of Silvânia, State of Goiás-\n' +
              'Brazil. The junction of technology, its privileged location, labor and raw materials enabled the\n' +
              'outset of the project for the corn grain processing facility through semi-humid process, for\n' +
              'the production of raw materials for the food industry, feed mills and other segments.\n' +
              'Due to the extensive raw material productivity in the region, it is possible to have total control\n' +
              'over the quality of GMO Free products produced by BRMill Alimentos. The quality control\n' +
              'management team along with our agronomists are capable of controlling the complete\n' +
              'production chain since the selection of the seeds planted by our local producers until the\n' +
              'final production stage at the grinding process at our facility, meeting with the strict product\n' +
              'management system.\n' +
              'The company, in its strategic plan, aims to promote the development of the region, which\n' +
              'until then had its foundations based on the agricultural economy, by adding value to society\n' +
              'and the local economy.',
        },
        differential: [
          {
            title: 'Location',
            description: 'The location is privileged, because in the region, there is great demand for the consumption of products derived from corn, in addition to being a strategic position to serve regions in full development such as the North and Northeast of the country. Established in the municipality of Silvânia-GO, 120 km from Goiânia, the company benefits from its privileged logistical position in the center of the country, which allows it to easily reach the national market, as well as having quick access to the main ports. Another factor worth mentioning is the supply of raw materials in the region, known for quality and productivity. The industry\'s demand will be easily met by the origination of local producers, in addition to that produced on the group\'s property.\n'
          },
          {
            title: 'Industrial Ingredient Solutions',
            description: 'BRMILL Alimentos is an agribusiness specialized in the production of corn-based ingredients, with a focus on providing solutions for the processing industry. BRMILL Alimentos products classified as Canjicão, Canjicas, Grits, Semolina, Fubá, are produced with the purpose of serving the following segments: snack industries, “snacks”, sweet popcorn, breweries, colors, spices, cake mixes, mills and direct packaging for retail, in addition to other companies in the field of adhesives, papers, textiles, mining. Corn germ is used in the animal feed formulation and oil extraction industries.'
          }
        ],
        metas: [
          {
            title: 'MISSION',
            description: 'To offer products derived from corn, with high quality and technology, seeking to maximize\n' +
                'the results of the company and clients, from a continuous evolution of the team and\n' +
                'processes.'
          },
          {
            title: 'VISION',
            description: 'To be a high-performance industry in the food segment, valued by customers for its\n' +
                'differentiated and effective solutions.'
          },
          {
            title: 'VALUES',
            description: 'Guided by ethics, transparency and integrity of conduct with clients, either with partners or\n' +
                'with the community, the company continually strives for excellence.'
          }
        ],
        footer: {}
      },
      es: {
        nav: {},
        slides: {
          s1: 'Alta Tecnología en la Producción',
          s2: 'Producción Propia de la Materia Prima',
          s3: 'Plantación Especializada',
          s4: 'Alta Calidad de los Granos'
        },
        history: {
          title: 'BRMILL ALIMENTOS',
          sub: 'Historia',
          description: 'BRMill Alimentos, empresa del grupo Agropecuária São Miguel, nació de la necesidad de agregar valor a los granos producidos en la región de Silvânia, estado de Goiás - Brasil. La combinación de tecnología, ubicación privilegiada, mano de obra y materia prima permitió el inicio del proyecto de procesamiento de granos de maíz por medio de un proceso semihúmedo, para la producción de ingredientes para la industria de alimentos, nutrición animal y otros segmentos. \n' +
              'Como resultado de la alta productividad de materia prima en la región, tenemos total control sobre la calidad del producto GMO Free producido por BRMill Alimentos, desde la selección de las semillas hasta la molienda de los granos, respectando los más estrictos criterios de producción. Además, en su planificación estratégica, la empresa tiene como objetivo impulsar el desarrollo de la región, que hasta entonces tenía sus raíces ​​en la economía agrícola, agregando valor a la sociedad y economía local.'

        },
        differential: [
          {
            title: 'Ubicación',
            description: 'La ubicación es privilegiada ya que existe una gran demanda en la región para el consumo de productos derivados del maíz, además de ser una posición estratégica para atender regiones en pleno desarrollo como el Norte y Noreste del país.' +
                'Establecida en el municipio de Silvânia, estado de Goiás ( cerca de 120 km de Goiânia), la empresa se beneficia de una posición logística privilegiada en el centro del país, que le permite atender fácilmente a los clientes del mercado nacional, además de tener rápido acceso a los principales puertos brasileños. Otro factor importante de mencionar es el suministro de materias primas en la región, conocida por su calidad y productividad. La demanda de la industria eres fácilmente atendida con los granos de productores locales, además de la producida en la propiedad del grupo.'
          },
          {
            title: 'Soluciones en Ingredientes Industriales',
            description: 'BRMILL Alimentos es una agroindustria especializada en la producción de ingredientes a base de maíz, con el objetivo de ofrecer soluciones para la industria de transformación. Los productos de BRMILL Alimentos clasificados como Maíz Entero Desgerminado, Maíz Trillado, Grits, Sémolas y Harinas, son producidos con el objetivo de atender los siguientes segmentos: industria de bocadillos “snacks”, palomitas de maíz inflado, cervecerías, coloríficos, condimentos, cereales matinales (cornflakes/ copos de maíz), empanados, moliendas, además de empresas en los sectores de adhesivos, papel, textiles, minería. El germen de maíz es destinado para industrias de formulación de alimentos para animales y extracción de aceite.'
          }
        ],
        metas: [
          {
            title: 'MISIÓN',
            description: 'Ofrecer productos derivados del maíz, con alta calidad y tecnología, buscando maximizar los resultados de la empresa y de los clientes a partir de una evolución continua del equipo y de los procesos.'

          },
          {
            title: 'VISIÓN',
            description: 'Ser una industria de alto desempeño en el segmento de alimentos, valorada por los clientes por sus soluciones diferenciadas y efectivas.'
          },
          {
            title: 'VALORES',
            description: 'Guiada por la ética, transparencia y la integridad de conducta, ya sea con los clientes, los socios o la comunidad, la empresa busca constantemente la excelencia.'
          }
        ],
        footer: {}
      }
    }
  },
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }

    switch (this.language) {
      case 'en':
        this.data = this.en;
        break;
      case 'es':
        this.data = this.es;
        break;
      default:
        this.data = this.pt;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hero {
  padding-top: 7rem;
  width: 100%;
  height: 500px;
  text-align: left;
}

</style>
